import { defineStyleConfig, StyleThemingProps } from '@chakra-ui/styled-system'
import { useStyleConfig } from '@chakra-ui/system'
import { getName } from '~/utils/objectUtils'

import { sharedComponentColorKeys } from './_colors'

const { CircleBadge: Colors } = sharedComponentColorKeys

export const enum CircleBadgeVariant {
  Blue = 'blue',
  Green = 'green',
  Red = 'red',
  Gray = 'gray',
}

export const CircleBadgeStyle = defineStyleConfig({
  baseStyle: {
    boxSize: '1rem',
    borderRadius: 'full',
    flexShrink: 0,
  },
  variants: {
    [CircleBadgeVariant.Blue]: {
      bg: Colors.Blue.Background.Steady,
    },
    [CircleBadgeVariant.Green]: {
      bg: Colors.Green.Background.Steady,
    },
    [CircleBadgeVariant.Red]: {
      bg: Colors.Red.Background.Steady,
    },
    [CircleBadgeVariant.Gray]: {
      bg: Colors.Gray.Background.Steady,
    },
  },
})

export const useCircleBadgeStyle = (props?: StyleThemingProps) => {
  return useStyleConfig(getName({ CircleBadgeStyle }), props)
}
